import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ModalSelectDate from "components/ModalSelectDate";
import ModalReserveMobile from "./ModalReserveMobile";
import { handleGuestsChange } from "utils/booking";
import { setSingleDate } from "features/bookingSlice";

const MobileFooterSticky = ({
  component,
  price = "",
  selectedOption = "",
  handleReserve,
}) => {
  const dispatch = useDispatch();
  const { dateRange, guests } = useSelector((state) => state.booking);

  // Initialize the state with default values or from the Redux store
  const [selectedDate, setSelectedDate] = useState(
    dateRange.startDate ? moment(dateRange.startDate) : moment().add(4, "days")
  );

  const [guestsState, setGuestsState] = useState({
    guestAdults: guests.guestAdults ?? 0,
    guestChildren: guests.guestChildren ?? 0,
    guestInfants: guests.guestInfants ?? 0,
  });

  // Update Redux state with selected date range
  const handleDateChange = (dates) => {
    setSelectedDate(dates);
    dispatch(setSingleDate(dates));
  };

  // Handle guests change using the helper function
  const handleGuestsChangeWrapper = (data) => {
    handleGuestsChange(data, setGuestsState, dispatch);
  };

  const bookingState = useSelector((state) => state.booking);

  const showModal = bookingState.showModal;

  return (
    <div
      className={`block lg:hidden fixed bottom-0 inset-x-0 py-2 sm:py-3 bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-6000 ${
        showModal ? "z-0 " : "z-20"
      }`}
    >
      <div className="container flex items-center justify-between">
        <div className="">
          <span className="block text-xl font-semibold">
            {price}
            <span className="ml-1 text-sm font-normal text-neutral-500 dark:text-neutral-400">
              /slot
            </span>
          </span>
          <ModalSelectDate
            defaultValue={selectedDate}
            component={component}
            onSelectDate={handleDateChange}
            renderChildren={({ openModal }) => (
              <span
                onClick={openModal}
                className="block text-sm underline font-medium"
              >
                {selectedOption}
              </span>
            )}
          />
        </div>
        <ButtonPrimary
          sizeClass="px-5 sm:px-7 py-3 !rounded-2xl"
          onClick={handleReserve}
        >
          Reserve
        </ButtonPrimary>
      </div>
    </div>
  );
};

export default MobileFooterSticky;
